import { createSlice } from '@reduxjs/toolkit';

export interface ModalState {
  modalType: string | null;
  modalProps: any;
}

const initialState: ModalState = {
  modalType: null,
  modalProps: {},
};

export const modalsSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    showModal: (state, action) => {
      const { modalType, modalProps } = action.payload;
      state.modalType = modalType;
      state.modalProps = modalProps;
    },
    hideModal: (state) => {
      state.modalType = null;
      state.modalProps = {};
    },
  },
});

export const { showModal, hideModal } = modalsSlice.actions;
export default modalsSlice.reducer;
